/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_footer_socials_stay_connected = /** @type {(inputs: {}) => string} */ () => {
	return `Zůstaňte v kontaktu`
};

const da_footer_socials_stay_connected = /** @type {(inputs: {}) => string} */ () => {
	return `Hold kontakten`
};

const de_footer_socials_stay_connected = /** @type {(inputs: {}) => string} */ () => {
	return `Bleiben Sie in Verbindung`
};

const en_footer_socials_stay_connected = /** @type {(inputs: {}) => string} */ () => {
	return `Let's stay connected`
};

const es_footer_socials_stay_connected = /** @type {(inputs: {}) => string} */ () => {
	return `Mantente conectado`
};

const fr_footer_socials_stay_connected = /** @type {(inputs: {}) => string} */ () => {
	return `Restons connectés`
};

const hu_footer_socials_stay_connected = /** @type {(inputs: {}) => string} */ () => {
	return `Maradjunk kapcsolatban`
};

const it_footer_socials_stay_connected = /** @type {(inputs: {}) => string} */ () => {
	return `Rimani connesso`
};

const nl_footer_socials_stay_connected = /** @type {(inputs: {}) => string} */ () => {
	return `Blijf verbonden`
};

const pl_footer_socials_stay_connected = /** @type {(inputs: {}) => string} */ () => {
	return `Bądźmy w kontakcie`
};

const pt_footer_socials_stay_connected = /** @type {(inputs: {}) => string} */ () => {
	return `Fique conectado`
};

const sv_footer_socials_stay_connected = /** @type {(inputs: {}) => string} */ () => {
	return `Håll kontakten`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const footer_socials_stay_connected = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer_socials_stay_connected(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("footer_socials_stay_connected", locale)
	if (locale === "cs") return cs_footer_socials_stay_connected(inputs)
	if (locale === "da") return da_footer_socials_stay_connected(inputs)
	if (locale === "de") return de_footer_socials_stay_connected(inputs)
	if (locale === "en") return en_footer_socials_stay_connected(inputs)
	if (locale === "es") return es_footer_socials_stay_connected(inputs)
	if (locale === "fr") return fr_footer_socials_stay_connected(inputs)
	if (locale === "hu") return hu_footer_socials_stay_connected(inputs)
	if (locale === "it") return it_footer_socials_stay_connected(inputs)
	if (locale === "nl") return nl_footer_socials_stay_connected(inputs)
	if (locale === "pl") return pl_footer_socials_stay_connected(inputs)
	if (locale === "pt") return pt_footer_socials_stay_connected(inputs)
	return sv_footer_socials_stay_connected(inputs)
};
export { footer_socials_stay_connected as "footer.socials.stay_connected" }